import { useThemeContext } from "../../theme/ThemeContextProvider";
import { FaLightbulb } from 'react-icons/fa'

const NightModeToggle = () => {
  const { toggleColorMode } = useThemeContext();

  return (
    <>
      <FaLightbulb onClick={toggleColorMode}/>
    </>
  );
};

export default NightModeToggle;
